// 개인정보 마스킹 유틸
// - 이름  : 첫 글자 제외 전체 마스킹       (홍길동      → 홍**)
// - 아이디: 첫 두 글자 제외 전체 마스킹     (abcdef     → ab****)
// - 이메일: @ 앞 두 글자 제외, @ 직전까지 마스킹 (abcdef@gmail.com → ab****@gmail.com)
class MaskUtil {
    static MASK_CHAR = "*";

    static maskName(name) {
        if (!name || typeof name !== "string") return name ?? "";
        const trimmed = name.trim();
        if (trimmed.length <= 1) return trimmed;
        return trimmed[0] + MaskUtil.MASK_CHAR.repeat(trimmed.length - 1);
    }

    static maskId(id) {
        if (!id || typeof id !== "string") return id ?? "";
        const trimmed = id.trim();
        if (trimmed.length <= 2) return trimmed;
        return trimmed.slice(0, 2) + MaskUtil.MASK_CHAR.repeat(trimmed.length - 2);
    }

    static maskEmail(email) {
        if (!email || typeof email !== "string") return email ?? "";
        const atIdx = email.indexOf("@");
        if (atIdx < 0) return MaskUtil.maskId(email);
        const local = email.slice(0, atIdx);
        const domain = email.slice(atIdx);
        if (local.length <= 2) return local + domain;
        return local.slice(0, 2) + MaskUtil.MASK_CHAR.repeat(local.length - 2) + domain;
    }
}

export default MaskUtil;
